"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.watchAppInsightsConsent = void 0;
const CookieManager_1 = require("../CookieManager");
const loadAppInsightsSdk_1 = require("./loadAppInsightsSdk");
const CONSENT_EVENTS = ['CookiebotOnAccept', 'CookiebotOnDecline'];
const COOKIES = ['ai_user', 'ai_session'];
const LOCAL_STORAGE_KEYS = ['ai_session'];
const SESSION_STORAGE_PREFIXES = ['AI_buffer', 'AI_sentBuffer'];
let appInsights;
let isEnabled = false;
const start = (connectionString) => __awaiter(void 0, void 0, void 0, function* () {
    if (isEnabled) {
        return;
    }
    isEnabled = true;
    try {
        const { ApplicationInsights } = yield (0, loadAppInsightsSdk_1.loadAppInsightsSdk)();
        if (!isEnabled || appInsights) {
            return;
        }
        const instance = new ApplicationInsights({
            config: {
                connectionString,
                enableSessionStorageBuffer: false
            }
        });
        instance.loadAppInsights();
        instance.trackPageView();
        appInsights = instance;
    }
    catch (_a) {
        isEnabled = false;
    }
});
const stop = () => {
    isEnabled = false;
    if (appInsights) {
        appInsights.getSender().pause();
        appInsights.unload(false);
        appInsights = undefined;
    }
    COOKIES.forEach(CookieManager_1.deleteCookie);
    LOCAL_STORAGE_KEYS.forEach(key => localStorage.removeItem(key));
    Object.keys(sessionStorage)
        .filter(key => SESSION_STORAGE_PREFIXES.some(prefix => key.startsWith(prefix)))
        .forEach(key => sessionStorage.removeItem(key));
};
const watchAppInsightsConsent = (connectionString) => {
    const onConsentChange = () => {
        var _a, _b;
        if ((_b = (_a = window.Cookiebot) === null || _a === void 0 ? void 0 : _a.consent) === null || _b === void 0 ? void 0 : _b.statistics) {
            start(connectionString);
        }
        else {
            stop();
        }
    };
    CONSENT_EVENTS.forEach(event => window.addEventListener(event, onConsentChange));
    return () => CONSENT_EVENTS.forEach(event => window.removeEventListener(event, onConsentChange));
};
exports.watchAppInsightsConsent = watchAppInsightsConsent;
